export const INVALID_PAYLOAD = "INVALID_PAYLOAD";
export const CHANGE_EVICE_CURRENT_REQ = "@CHANGE/CHANGEDEVICE_CURRENT_REQ";
export const CHANGE_DEVICE_CURRENT_SUCCESS = "@CHANGE/CHANGEDEVICE_CURRENT_SUCCES";
export const CHANGE_DEVICE_CURRENT_FAIL = "@CHANGE/CHANGEDEVICE_CURRENT_FAIL ";
export const CHAGE_DEVICE_EDIT = "@CHANGE/CHAGE_DEVICE_EDIT";
export const CHANGE_DEVICE_DELETE = "@CHANGE/CHANGE_DEVICE_DELETE"
export const CHANGE_DEVICE_DELETE_SUCCESS = "@CHANGE/CHANGE_DEVICE_DELETE_SUCCESS";


